import { TextField, TextFieldProps } from "@mui/material";
import { Controller } from "react-hook-form";
import { ReactHookFormBaseProps } from "../../types/ReactHookForm/ReactHookFormBaseElement";

type TextFieldElementProps = ReactHookFormBaseProps & Omit<TextFieldProps, "name" | "error">;

export default function TextFieldElement({ name, rules, helperText = "", ...rest }: TextFieldElementProps) {
  return (
    <Controller
      name={name}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...rest}
          {...field}
          value={field.value ?? ""}
          error={!!error}
          helperText={error ? error.message : helperText}
        />
      )}
    />
  );
}
